import React from 'react';
import {TextMode} from "../../../../utils/constants/contract";
import styles from "../../../../styles/contract.module.css"
import {AiOutlineClose} from "react-icons/ai"
// interface Props {
//   inputRef: RefObject<HTMLInputElement>;
//   text?: string;
//   mode: string;
//   width: number;
//   size?: number;
//   height: number;
//   lineHeight?: number;
//   fontFamily?: string;
//   positionTop: number;
//   positionLeft: number;
//   toggleEditMode: () => void;
//   handleMouseDown: DragEventListener<HTMLDivElement>;
//   handleMouseUp: DragEventListener<HTMLDivElement>;
//   handleMouseMove: DragEventListener<HTMLDivElement>;
//   handleMouseOut: DragEventListener<HTMLDivElement>;
//   onChangeText: (e: React.ChangeEvent<HTMLInputElement>) => void;
// }

export const TextInput = ({
  text,
  width,
  height,
  inputRef,
  mode,
  size,
  fontFamily,
  positionTop,
  positionLeft,
  onChangeText,
  toggleEditMode,
  handleMouseDown,
  handleMouseMove,
  handleMouseOut,
  handleMouseUp,
  lineHeight,
  removeAttachment,
  isEditable
}) => {
  return (
      <>
          {!!isEditable && (
          <div
              style={{
                  width,
                  height,
                  lineHeight,

                  top: positionTop,
                  left: positionLeft,
                  wordWrap: 'break-word',
                  padding: 0,
                  position: 'absolute',
              }}
          >
              <input
                  type="text"
                  ref={inputRef}
                  className={`${styles.disabled__pdf__input} ${styles.disabled__pdf__input__color}`}
                  onChange={onChangeText}
                  style={{
                      height,
                      fontSize:size,
                  }}
                  value={text}
              />
          </div>)}
          {!isEditable && (<div
              onMouseDown={handleMouseDown}
              onMouseMove={handleMouseMove}
              onMouseUp={handleMouseUp}
              onMouseOut={handleMouseOut}
              onDoubleClick={toggleEditMode}
              style={{
                  width,
                  cursor: mode === TextMode.COMMAND ? 'move' : 'default',
                  top: positionTop,
                  left: positionLeft,
                  padding: 0,
                  position: 'absolute',
              }}
          >
              <input
                  type="text"
                  ref={inputRef}
                  disabled
                  onChange={onChangeText}
                  readOnly
                  style={{cursor: mode === TextMode.COMMAND ? 'move' : 'text'}}
                  className={styles.disabled__pdf__input}
                  value={text}
              />
              <button type={"button"} onClick={removeAttachment} className={styles.remove__pdf__field}>
                <AiOutlineClose/>
              </button>
          </div>)}
      </>

  );
};
